document.addEventListener('DOMContentLoaded', () => {
  const faqTriggers = document.querySelectorAll('[data-faq-trigger]');
  const faqContainers = document.querySelectorAll('[data-faq-container]');
  
  // First, set all FAQ containers to height 0 initially
  faqContainers.forEach((container) => {
    if (!container.hasAttribute('data-faq-open')) {
      container.style.height = '0';
      container.style.overflow = 'hidden';
    }
  });
  
  faqTriggers.forEach((trigger) => {
    if (!trigger.hasAttribute('aria-expanded')) {
      trigger.setAttribute('aria-expanded', 'false');
    }
    
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !expanded);
      
      const container = trigger.nextElementSibling;
      if (container && container.hasAttribute('data-faq-container')) {
        if (!expanded) {
          container.style.height = 'auto';
          const height = container.scrollHeight;
          container.style.height = '0';
          
          container.offsetHeight; // Force reflow
          
          container.style.transition = 'height 0.3s ease-in-out';
          container.style.height = height + 'px';
          container.setAttribute('data-faq-open', 'true');
        } else {
          container.style.height = container.scrollHeight + 'px';
          
          container.offsetHeight; // Force reflow
          
          container.style.transition = 'height 0.3s ease-in-out';
          container.style.height = '0';
          container.removeAttribute('data-faq-open');
        }
      }
    });
  });
  
  // Only open the first FAQ item if it has data-faq-open="true"
  const firstFaqItem = document.querySelector('[data-faq-container][data-faq-open="true"]');
  if (firstFaqItem) {
    firstFaqItem.style.height = 'auto';
    const height = firstFaqItem.scrollHeight;
    firstFaqItem.style.height = height + 'px';
    firstFaqItem.style.overflow = 'visible';
    
    const trigger = firstFaqItem.previousElementSibling;
    if (trigger && trigger.hasAttribute('data-faq-trigger')) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }
});